import {
  Viewer,
} from '@stereograph/teiaviewer';
import {
  LoadTwinCommand,
  PathPlugin,
  TeiaAuthDeveloperTool, TeiaPlugin, TeiaRequestDeveloperTool, TwinProjectApi,
} from '@stereograph/teiaviewer-plugins';
import { PluginsUIPlugin } from '@stereograph/teiaviewer-plugins-ui-react';
import {
  CameraGizmo,
  ViewportContainer,
  ViewportPlugin,
} from '@stereograph/teiaviewer-viewport-react';
import { useTranslation } from 'react-i18next';
import { AppDock } from './base/AppDock';
import { AppToolbar } from './base/AppToolbar';
import { PathDeveloperTool } from './devtools/PathDeveloperTool';

const viewer = new Viewer({
  debug: true,
  dev: {
    verbose: true,
  },
});

const authDevTool = new TeiaAuthDeveloperTool();
const requestDevTool = new TeiaRequestDeveloperTool();
const pathDevTool = new PathDeveloperTool();
viewer.registerPlugin('Teia', new TeiaPlugin(viewer));
viewer.registerPlugin('Path', new PathPlugin(viewer));
viewer.registerPlugin('Viewport', new ViewportPlugin(viewer));
viewer.registerPlugin('PluginUI', new PluginsUIPlugin(viewer));
viewer.developerTools.addTool(authDevTool);
viewer.developerTools.addTool(requestDevTool);
viewer.developerTools.addTool(pathDevTool);

/**
 * App component setting up a viewer and a viewport
 * @returns
 */
export const App = () => {
  const { ready } = useTranslation('teiaviewer');

  if (!ready) {
    return <></>;
  }

  return (
    <ViewportContainer
      viewer={viewer}
      sx={{
        width: '100vw',
        height: '100vh',
      }}
    >
      <CameraGizmo />
      <AppDock
        sx={{
          position: 'absolute',
          bottom: '13px',
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      />
      <AppToolbar
        sx={{
          position: 'absolute',
          top: '50%',
          right: '13px',
          transform: 'translateY(-50%)',
        }}
      />
    </ViewportContainer>
  );
};

const autoLoadData = async () => {
  if (authDevTool.isAuthenticated && !viewer.getPlugin('Teia').currentSource) {
    const urlParams = new URLSearchParams(location.search);
    const client = viewer.getPlugin('Teia').twinApiClient;
    const twins = await TwinProjectApi(client).getTwinProjectList();
    const twinProjectId = Number(urlParams.get('twinProjectId'));
    const twin = twins.data.find((t) => t.id === twinProjectId);

    if (twin) {
      const cmd = new LoadTwinCommand(viewer, twin);
      cmd.execute();
    }
  }
};

authDevTool.authController.signals.onUserLogin.connect(autoLoadData);
